import React from 'react';
import FranceMap from '../components/FranceMap';
import ResidenceHighlight from '../components/ResidenceHighlight';

const Residence: React.FC = () => {
  const services = [
    {
      title: "Accompagnement administratif",
      description: "Assistance personnalisée pour toutes les démarches administratives",
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      )
    },
    {
      title: "Logistique et maintenance",
      description: "Entretien régulier et interventions rapides pour le confort général",
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 4a2 2 0 114 0v1a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-1a2 2 0 100 4h1a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-1a2 2 0 10-4 0v1a1 1 0 01-1 1H7a1 1 0 01-1-1v-3a1 1 0 00-1-1H4a2 2 0 110-4h1a1 1 0 001-1V7a1 1 0 011-1h3a1 1 0 001-1V4z" />
      )
    },
    {
      title: "Animation quotidiennes",
      description: "Programme varié d'activités sociales et culturelles",
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 15.546c-.523 0-1.046.151-1.5.454a2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.704 2.704 0 01-3 0 2.704 2.704 0 00-3 0 2.701 2.701 0 01-1.5-.454M9 6v2m3-2v2m3-2v2M9 3h.01M12 3h.01M15 3h.01M21 21v-7a2 2 0 00-2-2H5a2 2 0 00-2 2v7h18zm-3-9v-2a2 2 0 00-2-2H8a2 2 0 00-2 2v2h12z" />
      )
    },
    {
      title: "Coaching sportif",
      description: "Activités physiques adaptées",
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
      )
    },
    {
      title: "Repas partagés",
      description: "Offre quotidienne et optionnelle à la disposition des résidents",
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
      )
    },
    {
      title: "Proximité urbaine",
      description: "Localisation idéale proche des commerces et services",
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
      )
    },
    {
      title: "Téléconcierge dédié",
      description: "Toutes nos résidences sont équipées du service de téléconciergerie Prudens",
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
      )
    },
    {
      title: "Sécurité",
      description: "Sécurité et urgence 24h/24",
      icon: (
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      )
    }
  ];

  return (
    <div>
      {/* Hero Section - photo */}
      <section className="relative py-24 md:py-28 text-white overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="/residence6.png"
            alt=""
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-prudens-bleu-fonce/70" aria-hidden="true" />
        </div>
        <div className="container-custom relative z-10">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Prudens Résidence
          </h1>
          <p className="text-xl max-w-3xl text-white/95">
            Chez soi avec l'essentiel à portée de main
          </p>
        </div>
      </section>

      {/* Qu'est-ce que c'est ? */}
      <section className="py-16 bg-gray-100">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-12 items-center">
            <div>
              <h2 className="section-title mb-6">Prudens Résidence, qu'est-ce que c'est ?</h2>
              <ul className="space-y-3 text-lg text-gray-600 leading-relaxed">
                <li className="flex items-start gap-3">
                  <span className="flex-shrink-0 mt-0.5 w-5 h-5 rounded-full bg-prudens-bleu-fonce flex items-center justify-center" aria-hidden="true">
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </span>
                  <span>Des résidences pensées pour bien vieillir en autonomie</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="flex-shrink-0 mt-0.5 w-5 h-5 rounded-full bg-prudens-bleu-fonce flex items-center justify-center" aria-hidden="true">
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </span>
                  <span>Des résidences pour des séniors modestes financées par les bailleurs sociaux</span>
                </li>
              </ul>
            </div>
            <div className="rounded-xl overflow-hidden shadow-xl bg-prudens-beige-sable">
              <img
                src="/residence8.png"
                alt="Résidence Prudens - lieux de vie pour seniors"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Notre philosophie */}
      <section className="py-16 bg-gray-100">
        <div className="container-custom">
          <h2 className="section-title text-center mb-10">Notre philosophie</h2>
          <div className="max-w-3xl mx-auto space-y-6">
            <p className="text-gray-600 text-lg leading-relaxed">
              Riche d'un projet social ambitieux et varié, Prudens Résidence entend répondre à la nécessité de devoir quitter un logement souvent chargé de souvenirs, qui n'est plus adapté ou bien trop éloigné, pour venir chercher une convivialité, des services, des animations, une sécurité et une proximité urbaine garants d'une meilleure qualité de vie. <strong>Ainsi on peut vivre chez soi sans être seul.</strong>
            </p>
          </div>
        </div>
      </section>

      {/* Découvrez notre résidence */}
      <section className="py-16 bg-gray-100">
        <div className="container-custom">
          <div className="text-center mb-8">
            <h2 className="section-title">Découvrez notre résidence</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Une résidence moderne et adaptée, conçue pour le confort et le bien-être de nos résidents.
            </p>
          </div>

          <p className="text-center text-gray-600 mb-6 italic">
            Explorez les différents espaces en survolant les points d'intérêt :
          </p>

          <ResidenceHighlight />
        </div>
      </section>

      {/* Services et fonctionnement */}
      <section className="py-16 bg-gray-100">
        <div className="container-custom">
          <h2 className="section-title text-center mb-12">Services et fonctionnement</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-xl shadow-xl border border-gray-200 p-6 hover:shadow-2xl transition-shadow duration-300"
              >
                <div className="bg-prudens-bleu-fonce h-12 w-12 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    {service.icon}
                  </svg>
                </div>
                <h3 className="text-lg font-bold text-prudens-bleu-fonce text-center mb-2">
                  {service.title}
                </h3>
                <p className="text-gray-600 text-center text-sm">
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 📍 Ajoute la carte ici */}
      <section className="py-16 bg-gray-100">
       <div className="container-custom">
         <h2 className="section-title text-center mb-8">
       Nos projets de résidences en cours
     </h2>
    <FranceMap />
  </div>
</section>

      

      {/* CTA 
      <section className="py-16 bg-prudens-bleu-fonce text-white">
        <div className="container-custom text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Envie d'en savoir plus sur nos résidences ?
          </h2>
          <p className="text-xl max-w-3xl mx-auto mb-8">
            Découvrez comment nous pouvons vous accompagner vers un nouveau chez-vous adapté à vos besoins.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="btn bg-white text-prudens-bleu-fonce hover:bg-prudens-beige-sable">
              Demander une visite
            </button>
            <button className="btn bg-transparent border-2 border-white text-white hover:bg-white hover:text-prudens-bleu-fonce">
              Télécharger notre brochure
            </button>
          </div>
        </div>
      </section>*/}
    </div>
  );
};

export default Residence; 